class RecentlyViewed {
  constructor() {
    this.productGrid = document.querySelector('[data-products-grid]');
    this.storage = window.localStorage;
    if (this.productGrid) {
      this.fetchAndRenderProducts();
    }
  }

  getViewedProducts() {
    const viewed = this.storage.getItem('recentlyViewed');
    return viewed ? JSON.parse(viewed) : [];
  }

  async fetchAndRenderProducts() {
    const productCards = this.getViewedProducts();
    if (productCards.length === 0) return;
    document.getElementById('rv-wrapper').classList.remove('dn');

    this.productGrid.innerHTML = productCards.map((v) => v.content).join('');

    const container = document.getElementById('rv-wrapper');
    const gridId = container.querySelector('.scroll-grid').id;
    const grid = container.querySelector('.scroll-grid');
    const leftButton = container.querySelector(`.scroll-left[data-grid="${gridId}"]`);
    const rightButton = container.querySelector(`.scroll-right[data-grid="${gridId}"]`);

    const scrollAmount = 296; // 280px + 16px gap

    // Add click handlers for this specific grid
    if (leftButton) {
      leftButton.addEventListener('click', () => {
        grid.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth',
        });
      });
    }

    if (rightButton) {
      rightButton.addEventListener('click', () => {
        grid.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
      });
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new RecentlyViewed();
});
